package net.gorillagroove.discovery

import net.gorillagroove.api.Api
import net.gorillagroove.api.DownloadResponse

// IDK what to call this file. Leave me alone.
object BonusFileDownloads {
    @Throws(Throwable::class)
    suspend fun downloadFireFoxExtension(): DownloadResponse {
        return Api.download(Api.BASE_URL + "file/firefox-extension/1.0.1")
    }

    @Throws(Throwable::class)
    suspend fun downloadYoutubeDownloadServerJavascript(): DownloadResponse {
        return Api.download(Api.BASE_URL + "file/download-server-code")
    }
}
